<template>
  <section>
    <!-- 审批人循环组装 -->
    <div class="clear" v-for="(approval, a) in approvalUsers">
      <el-form-item>
        <div class="tab-title">
          <span class="title">{{ approval.name }}</span>
        </div>
      </el-form-item>
      <div class="form-item left mx" v-for="(users, j) in approval.users">
        <label v-html="users"></label>
        <div
          class="person-room"
          style="margin-top: 0px"
          v-if="
            selectArr['arr_' + a + '_' + j] &&
            selectArr['arr_' + a + '_' + j].length > 0
          "
        >
          <span
            class="persion-item"
            v-for="(user, i) in selectArr['arr_' + a + '_' + j]"
          >
            {{ user.name }}
            <i
              @click="deleteUsers(a + '_' + j, i)"
              class="iconfont icon-close1"
            ></i>
          </span>
        </div>
        <div class="add-person">
          <el-button
            @click="addUsers(a + '_' + j)"
            type="primary"
            size="mini"
            icon="el-icon-circle-plus-outline"
            >添加人员
          </el-button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["approvalUsers", "selectArr", "approvalSetDep"],
  computed: {
    ...mapState({
      contactSelectArr: (state) => state.main.contactSelectArr,
      contactApprovalItem: (state) => state.main.contactApprovalItem,
    }),
  },
  data() {
    return {
      // 意见与审批
      userType: 1,
    };
  },
  created() {},
  mounted() {
    console.log(this.selectArr);
  },
  methods: {
    // 删除人员
    deleteUsers(type, index) {
      this.selectArr["arr_" + type].splice(index, 1);
    },
    // 添加人员
    addUsers(type, isSingle) {
      this.userType = type;

      let _arr = this.selectArr["arr_" + type]
        ? this.selectArr["arr_" + type]
        : [];
      let _depId = this.approvalSetDep["arr_" + type]
        ? this.approvalSetDep["arr_" + type]
        : 0;

      this.$store.commit("set_contactSelectArr", _arr);
      this.$store.commit("set_contactApprovalDep", _depId);

      this.$store.commit("set_contactApprovalItem", true);
      this.$store.commit("set_contactShow", true);
      if (isSingle == "false") {
        this.$store.commit("set_contactSingleSelect", false);
      } else {
        this.$store.commit("set_contactSingleSelect", true);
      }
    },
    getUserIds() {
      console.log(this.selectArr);

      // 组装审批人
      let _userIds = [];
      for (var key in this.selectArr) {
        // 检查是否是ApprovalUsers需要的审批人
        // 因为部分旧的历史审批人在部分情况下并不是需要的
        // 'arr_' + i + "_" + j
        let _index = key.split("_");
        if (
          this.approvalUsers[_index[1]] &&
          this.approvalUsers[_index[1]].users[_index[2]]
        ) {
          if (this.selectArr[key].length > 0) {
            _userIds.push(this.selectArr[key][0].id);
          } else {
            _userIds.push("%%");
          }
        }
      }
      return _userIds.join(",");
    },
  },
  watch: {
    // "selectArr"() {
    //   console.log(2)
    // },
    contactSelectArr() {
      if (this.contactSelectArr.length > 0 && this.contactApprovalItem) {
        this.$set(
          this.selectArr,
          "arr_" + this.userType,
          this.contactSelectArr
        );
        this.$store.commit("set_contactSelectArr", []);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/ApprovalItem.vue